import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, DELETE, PUT } from "../../../../services/index";
import { message } from "antd";

const ENDPOINT = "/api/v1/userBank";

/**
 * รายการข้อมูลธนาคารลูกค้า (แบ่งหน้า + ค้นหา)
 * company_id ถูกแนบให้อัตโนมัติจาก services/index.js
 */
export const useFetchUserBankList = ({ page = 1, pageSize = 20, search = "" } = {}) => {
  return useQuery(
    ["getUserBankList", page, pageSize, search],
    async () => {
      try {
        const url = `${ENDPOINT}/list?page=${page}&pageSize=${pageSize}&search=${encodeURIComponent(search)}`;
        const { result } = await GET(url);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("ไม่สามารถโหลดข้อมูลธนาคารลูกค้าได้");
        throw error;
      }
    },
    {
      keepPreviousData: true,
    }
  );
};

/**
 * รายชื่อธนาคารที่มีอยู่ในระบบ ไว้เป็นตัวเลือกในฟอร์ม
 */
export const useFetchBankOptions = () => {
  return useQuery(
    ["getUserBankOptions"],
    async () => {
      const { result } = await GET(`${ENDPOINT}/banks`);
      return result || [];
    },
    {
      staleTime: 5 * 60 * 1000,
    }
  );
};

export const useFetchCreateUserBank = () => {
  return useMutation(async (payload) => await POST(ENDPOINT, { ...payload }));
};

export const useFetchUpdateUserBank = () => {
  return useMutation(async (payload) => await PUT(ENDPOINT, { ...payload }));
};

export const useFetchDeleteUserBank = () => {
  return useMutation(async (id) => await DELETE(`${ENDPOINT}/${id}`));
};

/**
 * ดึงข้อมูลสมาชิกจากเว็บ MGB ตามช่วงวันที่สมัคร (ครั้งละไม่เกิน 31 วัน)
 * ⚠️ ส่ง payload ทั้งก้อนด้วย ...payload — เคยพลาดมาแล้วตอนหน้าโปรวันเกิด
 *    ที่ destructure เฉพาะบางฟิลด์แล้ว date หายไปเงียบ ๆ
 */
export const useSyncUserBank = () => {
  return useMutation(async (payload) => await POST(`${ENDPOINT}/sync`, { ...payload }));
};
